import { render, staticRenderFns } from "./dialog-replace-lock.vue?vue&type=template&id=20474664&scoped=true&"
import script from "./dialog-replace-lock.vue?vue&type=script&lang=js&"
export * from "./dialog-replace-lock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20474664",
  null
  
)

export default component.exports